import script from "./MobileFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileFooter.vue?vue&type=script&setup=true&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=6855fcac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6855fcac"]])

export default __exports__